import { useState } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import useSetFocus from '../../hooks/useSetFocus'
import { addField, createSignupError } from '../../features/signup/signupSlice' 

const FormContent = () => {
  const [surnameValue,setSurnameValue] = useState("");
  const [firstnameValue,setFirstnameValue] = useState("");
  const [othernamesValue,setOthernamesValue] = useState("");
  const [dateValue,setDateValue] = useState("");
  const [contactValue,setContactValue] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleSurnameChange(e){
    setSurnameValue(e.target.value);
  }

  function handleFirstnameChange(e){
    setFirstnameValue(e.target.value);
  }

  function handleOthernamesChange(e){
    setOthernamesValue(e.target.value);
  }

  function handleDateChange(e){
    setDateValue(e.target.value);
  }

  function handleContactChange(e){
    setContactValue(e.target.value);
  }

  const canContinueProfile = [surnameValue,firstnameValue,dateValue,contactValue].every(Boolean) 


  function handleSubmit(e){
    e.preventDefault();

     // add local state values to the signup global state
     if (canContinueProfile){
        dispatch(addField({
          surname:surnameValue,
          first_name:firstnameValue,
          other_name: othernamesValue,
          date_of_birth: dateValue,
          contact_number: contactValue,
        }))

        navigate('/signup/profile')
     }
     else{
      //To fix
      // error_message = `To Fix`
      // dispatch(createSignupError())
     }


  }


  //Custom hook to set focus on first input field
  useSetFocus('input[type="text"]');

  return (
    <Form action='#' method='post'>
      <div className="form-input">
        <input type="text" onChange={handleSurnameChange} name='surname' id='surname' className='input-field' required />
        <label for="surname" className={`input-label ${surnameValue && 'fixed'}`}>Surname</label>
      </div>
      <div className="form-input">
        <input type="text" onChange={handleFirstnameChange} name='firstname' id='firstname' className='input-field' required />
        <label for="firstname" className={`input-label ${firstnameValue && 'fixed'}`}>First Name</label>
      </div>
      <div className="form-input">
        <input type="text" onChange={handleOthernamesChange} name='othernames' id='othernames' className='input-field' required />
        <label for="othernames" className={`input-label ${othernamesValue && 'fixed'}`}>Other Names</label>
      </div>
      <div className="form-input date-input-form" >
        <input type="date" onChange={handleDateChange} name='dateOfBirth' id='dateOfBirth' className='input-field date-input-field' required />
        <label for="dateOfBirth" className="fixed input-label">Date Of Birth</label>
      </div>
      <div className="form-input" >
        <input type="tel" onChange={handleContactChange} name='contact' id='contact' className='input-field' required />
        <label for="contact" className={`input-label ${contactValue && 'fixed'}`}>Contact</label>
      </div>
      <button className='continue-btn' onClick={handleSubmit}>Continue</button>
    </Form>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1em;
  margin: 2em auto;
  .form-input{
    position: relative;
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: .5em auto;
      &:focus-within .input-label{
        transform: translate(0, -.5em) scale(0.8);
      }

    /* Date input field */
    .date-input-field{
      margin: .5em 0;
    }
    .input-field{
      width: 90%;
      padding: .7em 1em;
      border: none;
      outline: none;
      border-bottom: 1px solid var(--color-muted-black-light);
      font-size: 1.1rem;
      &:focus{
        border-bottom: 2px solid var(--primary-color);
      }
    }
    .input-label{
      position: absolute;
      pointer-events: none;
      transform: translate(0, .8em) scale(1);
      transform-origin: top left;
      transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
      color: var(--color-muted-black);
      font-size: 1rem;
      left: 1em;
    }
    .fixed{
      transform: translate(0, -.5em) scale(0.8);
    }
  }
  /* Date input form */
  .date-input-form{
    margin: 1em 0;
  }

  .continue-btn{
    width: 80%;
    padding: 1em 1em;
    border: none;
    border-radius: 50px;
    outline: none;
    font-size: 1.1rem;
    background-color: var(--primary-color);
    color: var(--color-white);
    cursor: pointer;
  }

  @media only screen and (min-width: 1200px) {
     .form-input{
      width: 70%;
     }
     .continue-btn{
      width: 60%;
     }
  }
`;

export default FormContent